<template>
    <div class="right-panel">
        <div class="wrap">
            <div>{{ editing_line.name }}</div>
            <el-button type="primary" @click="showLineDlg">增加线路</el-button>
            <div class="lines" v-if="editing_line.trackways && editing_line.trackways.length">
                <el-divider content-position="center">线路</el-divider>
                <div
                    v-for="(line, i) in editing_line.trackways"
                    :key="i"
                    class="item"
                    :class="{active: i === selected_line}"
                    @click="selectLine(i)"
                >
                    线路{{ i }}
                    <div :span="8" v-if="i === selected_line">
                        <el-button type="danger" icon="el-icon-delete" circle @click.stop="delLine"></el-button>
                    </div>
                </div>
            </div>
            <el-divider content-position="center">站点</el-divider>
            <div class="list">
                <div
                    v-for="(item, i) in editing_line.metro_stations"
                    :key="i"
                    align="center"
                    class="item"
                    :class="{ active: selected_station === i }"
                    @click="selectStation(i)"
                >
                    <div :span="16">
                        <i class="el-icon-map-location"></i>
                        {{ item.name }} {{ item.status === '预测' ? `(${item.status})` : ''}}
                    </div>
                </div>
            </div>
            <el-row class="bottom">
                <el-button type="success" plain @click="submit">确认</el-button>
            </el-row>
        </div>
        <el-dialog
            title="新建线路"
            :visible.sync="show_line_dlg"
            width="360px"
            center>
            <div class="line-type-box">
                <span class="line-title">线条样式：</span>
                <select class="line-select" v-model="line_style">
                    <option v-for="item in line_styles" :key="item.value" :value="item.value">
                        {{ item.name }}
                    </option>
                </select>
                <span>预测线路需要选择虚线</span>
            </div>
            <span>请选择起点站和终点站</span>
            <div class="list">
                <div
                    v-for="(item, i) in editing_line.metro_stations"
                    :key="i"
                    align="center"
                    class="item"
                    :class="{ active: line_stations.indexOf(i) > -1 }"
                    @click="selectLineStation(i)"
                >
                    <div :span="16">
                        <i class="el-icon-map-location"></i>
                        {{ item.name }} {{ item.status === '预测' ? `(${item.status})` : ''}}
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="show_line_dlg = false">取 消</el-button>
                <el-button v-if="line_stations && line_stations.length === 2" type="primary" @click="confirmLine">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex'

import API from '@/service/metro_editor'

export default {
    props: {
        type: String
    },
    computed: mapState({
        editing_line: state => state.MetroEditor && state.MetroEditor.editing_line,
        selected_line: state => state.MetroEditor && state.MetroEditor.selected_line,
        selected_station: state => state.MetroEditor && state.MetroEditor.selected_station,
    }),
    data () {
        return {
            name: '',
            show_line_dlg: false,
            line_stations: [],
            line_styles: [
                { name: '实线', value: 'solid_line' },
                { name: '虚线', value: 'dashed_line' },
            ],
            line_style: 'solid_line'
        }
    },
    methods: {
        showLineDlg () {
            this.show_line_dlg = true
        },
        selectStation (i) {
            this.$store.dispatch('MetroEditor/selectStation', i)
        },
        selectLine (i) {
            this.$store.dispatch('MetroEditor/selectLine', i)
        },
        delLine () {
            this.$store.dispatch('MetroEditor/delLine')
        },
        selectLineStation (i) {
            if (this.line_stations.length >= 2) {
                return
            }
            const index = this.line_stations.indexOf(i)
            if (index > -1) {
                this.line_stations.splice(index, 1)
            } else {
                this.line_stations.push(i)
            }
        },
        confirmLine () {
            const coordinate = this.line_stations.map((i) => {
                return this.editing_line.metro_stations[i].location
            })
            const params = {
                coordinate,
                line_style: this.line_style
            }
            this.$store.dispatch('MetroEditor/addLine', params)
            this.show_line_dlg = false
            this.line_stations = []
        },
        async submit () {
            const loading = this.$loading({
                lock: true,
                text: '提交中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            try {
                const { id } = this.$route.params
                await API.updateDetail(id, this.editing_line)
                this.$message({
                    message: '提交成功',
                    type: 'success'
                })
            } catch (err) {
                this.$message({
                    message: '提交失败, 请稍后重试',
                    type: 'error'
                })
            }
            loading.close()
        }
    }
}
</script>
<style lang="scss" scoped>
.right-panel {
    width: 20%;
    height: 100vh;
    padding: 20px;
    overflow-y: scroll;
    background-color: #fff;
}
.line-type-box {
    margin-bottom: 8px;
    .line-title {
        color: #333;
        font-weight: 500;
    }
    .line-select {
        width: 80px;
        margin-right: 16px;
    }
}
.list {
    max-height: 50vh;
    overflow-y: scroll;
}
.item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    border-bottom: 1px solid #e5e5e5;
    &:last-child {
        border: 0;
    }
    &.active {
        background-color: rgba(255, 80, 80, .6);
        color: #fff;
    }
}
.bottom {
    margin-top: 32px;
}
</style>